<template>
  <div class="text_editor">
    <section class="text_editor__button">
      <button :disabled="timeLeft > 0" @click="copy">Copy Text</button>
    </section>
    <div
      role="presentation"
      class="text_editor__progress"
      :class="{ running: text != '' }"
      :style="cssProps"
    ></div>

    <textarea
      class="text_editor__input scrollable text"
      placeholder="Start Typing..."
      v-model="text"
      oncopy="return false"
      onpaste="return false"
      spellcheck="false"
      @click="startErase"
      v-on="
        !this.sessionTimeComplete
          ? { keyup: startErase, keydown: stopErase }
          : {}
      "
    />
  </div>
</template>

<script>
export default {
  props: { time: { type: Number, default: 5 } },
  data: function() {
    return {
      //overall timer
      //time: 10, //milliseconds
      timePassed: 0,
      timerInterval: null,
      //content
      text: '',

      //internalTimers
      timeOutVal: 2000,
      textEraseTimer: null,
      charEraseTimer: null,

      sessionTimeComplete: false
    }
  },
  computed: {
    timeLeft() {
      return this.$props.time * 60 - this.timePassed
    },
    safe() {
      return this.timeLeft > 0 ? false : true
    },
    cssProps() {
      return {
        '--duration': this.time * 60 + 's'
      }
    }
  },
  methods: {
    countdown: function() {
      this.timePassed++
    },
    startTimer() {
      this.timerInterval = setInterval(() => {
        this.countdown()
        if (this.timeLeft <= 0) {
          clearInterval(this.timerInterval)
        }
      }, this.$props.time * 60)
    },
    startErase() {
      window.clearTimeout(this.textEraseTimer)
      this.textEraseTimer = window.setTimeout(() => {
        this.eraseLetters()
        window.clearTimeout(this.textEraseTimer)
      }, this.timeOutVal)
    },
    stopErase() {
      window.clearTimeout(this.charEraseTimer)
      window.clearTimeout(this.textEraseTimer)
    },
    eraseLetters() {
      const self = this
      var x = 0
      self.charEraseTimer = setInterval(function() {
        self.text = self.text.slice(0, -1)
        x++
        if (x >= 6) {
          window.clearInterval(self.charEraseTimer)
          self.emitFailure()
        }
      }, 500)
    },
    emitFailure: function() {
      clearInterval(this.timerInterval)
      this.$emit('emitfailure')
    },
    async copy() {
      await navigator.clipboard.writeText(this.text)
    }
  },
  mounted() {
    this.startTimer()
  },
  created() {
    this.unwatchIsLiveProp = this.$watch('text', () => {
      if (this.text != '') {
        this.$emit('editor-active')
        // Do stuff...
        this.unwatchIsLiveProp()
      }
    })
  }
}
</script>

<style>
.text_editor {
  position: relative;
  width: 100%;
}

.text_editor__input {
  display: block;
  width: 100%;
  height: 50vh;
  border: none;
  -webkit-user-select: none;
  user-select: none;
  border: 0.1rem solid var(--primary-color);
  font-size: 1.6rem;
  padding: 1.2rem;
  resize: vertical;
}
.text_editor__button {
  margin-bottom: 0.8rem;
}

.text_editor__progress {
  position: sticky;
  width: 0;
  height: 0.4rem;
  background: var(--primary-color);
  top: 0;
  left: 0;
  transition: width var(--duration) linear;
}
.text_editor__progress.running {
  width: 100%;
}
</style>
